import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import BusinessClientEsimUpgradeBlockData from '../../../Models/Content/BusinessClientEsimUpgradeBlockData';
import BusinessClientEsimUpgradeMain
  from "app/Components/Block/BusinessClientEsimUpgradeBlock/BusinessClientEsimUpgradeMain";


export default class BusinessClientEsimUpgradeBlock extends EpiComponent<BusinessClientEsimUpgradeBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <BusinessClientEsimUpgradeMain context={this.getContext()} contentData={this.props.data} />;
  }
}
